var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretUp = function SvgCaretUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C34CD",
    fillRule: "evenodd",
    d: "M12.53 8.47a.75.75 0 0 0-1.06 0l-4 4A.75.75 0 0 0 8 13.75h8a.75.75 0 0 0 .53-1.28z",
    clipRule: "evenodd"
  })));
};
export default SvgCaretUp;